import { isMobile } from "../bridges/BridgeServices";
import { getPlatformForBot } from "../components/Chatbot/ChatbotUtil";
import { TEMPLATES } from "./constants";

const getParentTopicData = (
  uri = "",
  allPagesData = {}
) => {
  let parentUri = allPagesData[uri]?.parentUri;
  if (parentUri === uri || uri === "" || !parentUri) {
    return { activeChildUri: "", childPages: [] };
  }

  if (
    allPagesData[parentUri]?.templateName ===
    TEMPLATES.TOPIC
  ) {
    const { "child-pages": childPages = [] } =
      allPagesData[parentUri] || {};

    return {
      activeChildUri: uri,
      childPages: childPages,
    };
  }
  return getParentTopicData(parentUri, allPagesData);
};

export const lastItem = arr => {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr[arr.length - 1];
  }
  return undefined;
};
export function uuid() {
  return window?.crypto?.randomUUID?.() || uuidFallback();
}
function uuidFallback() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (Math.random() * 16) | 0;
      // eslint-disable-next-line
      const v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
}
export default getParentTopicData;

export const getValueForQueryParam = function (queryParam) {
  try {
    let value = null;
    if (queryParam) {
      if (typeof URLSearchParams === "undefined") {
        queryParam = queryParam
          .replace(/[\[]/, "\\[")
          .replace(/[\]]/, "\\]");
        const regex = new RegExp(
          "[\\?&]" + queryParam + "=([^&#]*)"
        );
        const results = regex.exec(
          window.location.search || window.location.hash
        );
        value =
          results === null
            ? ""
            : decodeURIComponent(
                results[1].replace(/\+/g, " ")
              );
      } else {
        value = getParams().get(queryParam);
      }
    }
    return value;
  } catch {
    return null;
  }
};

export const getQueryParams = ({
  faqTitle = "",
  src,
} = {}) => {
  if (!window.token) {
    return;
  }
  const clonedToken = JSON.parse(
    JSON.stringify(window.token)
  );
  const email = clonedToken.userId + "@iris.phonepe.com";

  return {
    src: src || getValueForQueryParam("src") || "help",
    ...(faqTitle && {
      faqTitle,
    }),
    snId: window?.token?.token,
    xtrnlTcktId:
      getValueForQueryParam("txnId") ||
      getValueForQueryParam("conversationId") ||
      uuid(),
    data: getValueForQueryParam("data"),
    txnState: getValueForQueryParam("txnState"),
    errorCode: getValueForQueryParam("errorCode"),
    email: email,
    "cstmr::eml": email,
    "cstmr::nm": clonedToken.name,
    showWebHeader: getValueForQueryParam("showWebHeader"),
    platform:
      getValueForQueryParam("platform") ||
      getPlatformForBot(),
  };
};

export const getQueryString = queryObj => {
  if (typeof URLSearchParams === "undefined") {
    return (
      "?" +
      Object.keys(queryObj)
        .map(key => {
          return `${key}=${encodeURIComponent(
            queryObj[key]
          )}`;
        })
        .join("&")
    );
  } else {
    return "?" + new URLSearchParams(queryObj).toString();
  }
};

const getParams = () => {
  try {
    return new URLSearchParams(
      window.location.search ||
        window.location.hash.slice(
          window.location.hash.search(/[?]/g)
        )
    );
  } catch {
    return new URLSearchParams("");
  }
};

export const appendSearchParamsToURL = (
  key = "",
  value = ""
) => {
  const params = getParams();
  try {
    if (key) {
      params.set(key, value);
    }
    return params.toString();
  } catch {
    return params.toString();
  }
};

export const isShowWebHeader = () => {
  const showWebHeader = getValueForQueryParam(
    "showWebHeader"
  );
  return !!showWebHeader;
};

export const createRedirectURL = uri => {
  try {
    let params = getParams();
    return `${uri}?${params}`;
  } catch {
    return uri;
  }
};

export const convertTimeTo12HourSystem = time => {
  try {
    const timeSplit = time.split(":");
    const hours = timeSplit[0] % 12 || 12;
    const minutes = timeSplit[1];
    const amOrPm = timeSplit[0] >= 12 ? "PM" : "AM";

    return `${hours}:${minutes} ${amOrPm}`;
  } catch {
    return "";
  }
};

export const checkIfIVRAvailable = (startTime, endTime) => {
  try {
    const date = new Date();
    const presentHours = date.getHours();
    const presentDay = date.getDay();
    const endTimeSplit = endTime.split(":");
    const startTimeSplit = startTime.split(":");

    return (
      endTimeSplit[0] > presentHours &&
      startTimeSplit[0] < presentHours &&
      presentDay !== 6 &&
      presentDay !== 0
    );
  } catch {
    return false;
  }
};
